// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/stylesheets/panels/metadataWidget.styl
// module id = 138
// module chunks = 0